import User from '@models/user';
import Vue from 'vue';

const userState = {
  profileState: 'idle',
  currentUser: { uid: null },
  selectedUserImage: [],
  watchedUsers: {}
};

const userActions = {
  watchOnlineStatus() {
    const amOnline = this._vm.firebase.database().ref().child('/.info/connected');
    const uid = this._vm.firebase.auth().currentUser.uid;
    const userRef = this._vm.firebase.database().ref().child('users').child(uid);
    const timestamp = this._vm.firebase.database.ServerValue.TIMESTAMP;
    amOnline.on('value', function(snapshot) {
      if (snapshot.val()) {
        userRef.child('status').onDisconnect().set('offline');
        userRef.child('last_online_at').onDisconnect().set(timestamp);
        userRef.child('status').set('online');
      }
    });
  },
  watchUser(store, id) {
    if (store.state.watchedUsers[id]) return;
    const database = this._vm.firebase.database();
    const ref = database.ref().child('users').child(id);
    ref.on("value", (snap) => {
      let user = snap.val();
      if (user) {
        user.uid = id;
        store.commit("setWatchedUser", { id, user: user });
      }
    });
  },
  watchCurrentUser({ commit }, id) {
    const database = this._vm.firebase.database();
    const ref = database.ref().child('users').child(id);

    ref.on("value", (snap) => {
      let user = snap.val();
      if (user) user = User.fromSnapshot(snap);
      commit("setCurrentUser", user);
    });
  },
  watchLoggedInUser({ commit, dispatch }, id) {
    const database = this._vm.firebase.database();
    const ref = database.ref().child('users').child(id);
    ref.on("value", (snap) => {
      let user = snap.val();
      if (user) {

        if (!user['estimate-location']) {
          dispatch("getGeoip", "all");
        }
        user = User.fromSnapshot(snap);
      } else {
        dispatch("getGeoip");
      }
      commit("setLoggedInUser", user);
    });
  }
};

const userGetters = {
  getProfileState: state => state.profileState,
};

const userMutations = {
  setLoggedInUser(state, user) {
    state.loggedInUser = user;
  },
  setWatchedUser(state, { id, user }) {
    Vue.set(state.watchedUsers, id, user);
  },
  setProfileStateEmpty(state) {
    state.profileState = 'empty';
  },
  setProfileStateLoaded(state) {
    state.profileState = 'loaded';
  },
};

export {
  userState,
  userActions,
  userGetters,
  userMutations
};
